// extracted by mini-css-extract-plugin
export default {"root":"ReportLink_root__UmYy1"};